export const LADLE_CAR_COLORS = {
  // Orange soft
  lc1: {
    bg: "#FFF3E0", // Orange light
    border: "#FFB74D", // Orange medium
    hover: "#FFE0B2", // Orange hover
  },
  // Green mint
  lc2: {
    bg: "#E8F5E9", // Green light
    border: "#81C784", // Green medium
    hover: "#C8E6C9", // Green hover
  },
};
